(function () {
  const modal = document.getElementById('jl-qv');
  const content = document.getElementById('jl-qv-content');
  const loader = document.getElementById('jl-qv-loader');
  if (!modal || !content) return;

  const SECTION_ID = 'jlore-quick-view';
  let activeTrigger = null;
  let abortController = null;
  let lastFocused = null;

  function cartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function formatMoney(cents, moneyFormat) {
    const amount = cents / 100;
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(amount, moneyFormat || '{{amount}}');
    }
    return 'EGP ' + Math.round(amount).toLocaleString('en-US');
  }

  function normalizeImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    if (url.startsWith('//')) return window.location.protocol + url;
    return url;
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('jl-qv--open');
    document.body.classList.add('jl-qv-open');
    const closeBtn = modal.querySelector('.jl-qv__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('jl-qv--open');
    document.body.classList.remove('jl-qv-open');
    content.innerHTML = '';
    if (loader) loader.hidden = true;
    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    } else if (lastFocused) {
      lastFocused.focus();
    }
  }

  function getVariantById(variants, id) {
    return variants.find(function (v) {
      return String(v.id) === String(id);
    }) || null;
  }

  function getColorValue(variant, colorOptionIndex) {
    if (!variant) return '';
    if (Array.isArray(variant.options)) {
      return variant.options[colorOptionIndex] || variant.options[0] || '';
    }
    return '';
  }

  function initQuickViewPanel(panel) {
    let variants = [];
    try {
      variants = JSON.parse(panel.querySelector('#jl-qv-variants-json')?.textContent || '[]');
    } catch (e) {
      variants = [];
    }

    const moneyFormat = panel.dataset.moneyFormat || '{{amount}}';
    const colorOptionIndex = panel.dataset.colorOptionIndex != null
      ? Number(panel.dataset.colorOptionIndex)
      : 0;
    const variantInput = panel.querySelector('#jl-qv-variant-id');
    const priceEl = panel.querySelector('#jl-qv-price');
    const tabbyEl = panel.querySelector('.jl-qv-panel__tabby');
    const colorName = panel.querySelector('#jl-qv-color-name');
    const imgEl = panel.querySelector('#jl-qv-image');
    const addBtn = panel.querySelector('#jl-qv-add');
    const form = panel.querySelector('#jl-qv-form');

    function updateAvailability(variant) {
      if (!addBtn || !variant) return;
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Bag';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
    }

    function applyVariant(variant, displayName, imageUrl) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (tabbyEl) {
        tabbyEl.textContent = 'or 3× ' + formatMoney(Math.round(variant.price / 3), moneyFormat) + ' with Tabby';
      }
      if (colorName && displayName) colorName.textContent = displayName;

      const image = normalizeImageUrl(imageUrl) || normalizeImageUrl(variant.featured_image);
      if (imgEl && image) {
        imgEl.removeAttribute('srcset');
        imgEl.src = image;
        imgEl.alt = displayName || imgEl.alt;
      }

      updateAvailability(variant);
    }

    panel.querySelectorAll('.jl-sw').forEach(function (sw) {
      sw.addEventListener('click', function () {
        panel.querySelectorAll('.jl-sw').forEach(function (s) {
          s.classList.remove('active');
          s.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('active');
        sw.setAttribute('aria-checked', 'true');

        const variant = getVariantById(variants, sw.dataset.variantId);
        const name = sw.dataset.name || getColorValue(variant, colorOptionIndex);
        const imageUrl = sw.getAttribute('data-image') || '';
        applyVariant(variant, name, imageUrl);
      });
    });

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!addBtn || addBtn.disabled) return;

        const originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        try {
          const response = await fetch(cartRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: new FormData(form)
          });

          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          addBtn.textContent = 'Added to Bag';
          const cartRes = await fetch(cartRoot() + 'cart.js');
          const cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: { source: 'jlore-quick-view', itemCount: cart.item_count }
            }
          }));
          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
            cartDrawer.showDialog();
          }

          window.setTimeout(function () {
            closeModal();
          }, 500);
        } catch (error) {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }
      });
    }

    const initialVariant = getVariantById(variants, variantInput?.value);
    if (initialVariant) {
      updateAvailability(initialVariant);
    }
  }

  async function openQuickView(trigger) {
    const productUrl = trigger.getAttribute('data-product-url');
    if (!productUrl) return;

    activeTrigger = trigger;
    abortController?.abort();
    abortController = new AbortController();

    content.innerHTML = '';
    if (loader) loader.hidden = false;
    openModal();

    try {
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', SECTION_ID);

      const response = await fetch(url.toString(), {
        signal: abortController.signal,
        headers: {
          Accept: 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to load quick view');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.jl-qv-panel') || doc.querySelector('[data-jl-qv-panel]');

      if (!section) {
        throw new Error('Quick view content missing');
      }

      content.innerHTML = section.outerHTML;
      const panel = content.querySelector('[data-jl-qv-panel]');
      if (panel) initQuickViewPanel(panel);
    } catch (error) {
      if (error.name === 'AbortError') return;
      content.innerHTML = '<p class="jl-qv-panel__error">Could not load this product. <a href="' + productUrl + '">View product page</a>.</p>';
    } finally {
      if (loader) loader.hidden = true;
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-jl-quick-view]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openQuickView(trigger);
  });

  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-jl-qv-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('jl-qv--open')) {
      closeModal();
    }
  });

  closeModal();
})();
